import React from 'react';
import _ from 'underscore';
import { ReactTemplate } from '@bingads-webui-react/react-template';

import AudienceAdsImg from '../../media/AudienceAds_animated.gif';
// import ProductAdsImg from '../../media/ProductAds_animated.gif';
import SearchAdsImg from '../../media/SearchAds_animated.gif';
import SmartShoppingImg from '../../media/SmartShopping.gif';
import StandardShoppingImg from '../../media/StandardShopping.gif';
import PerformanceMaxImg from '../../media/PerformanceMax.gif';
import VideoCampaignCTV from '../../media/VideoCampaignCTV.svg';
import VideoCampaignWeb from '../../media/VideoCampaignWeb.svg';
import NativeAdsImg from '../../media/img_Native.svg';
import DisplayAdsImg from '../../media/img_Banner.svg';
import MicrosoftRetailerNetworkImg from '../../media/MicrosoftRetailerNetwork.svg';
import SponsoredPromotionsByBrandImg from '../../media/SponsoredPromotionsByBrand.svg';

export const adTypeConfig = (i18n, showAsCampaignType) => [{
  id: 'SearchAds',
  title: showAsCampaignType ? i18n.getString(_TL_('Search')) : i18n.getString(_TL_('Search ads')),
  description: i18n.getString(_TL_('Reach potential customers who have displayed search intent for your products and services. These ads can appear with search results on sites like Microsoft Bing, AOL, Yahoo, DuckDuckGo, Ecosia, and other partners. These ads can also extend into relevant sites across the Microsoft Advertising Network to maximize your conversions and reach your performance goal.')),
  helpTopicId: 'app50028',
  img: SearchAdsImg,
  'aria-label': showAsCampaignType ? i18n.getString(_TL_('Search')) : i18n.getString(_TL_('Search ads')),
}, {
  id: 'AudienceAds',
  title: showAsCampaignType ? i18n.getString(_TL_('Audience')) : i18n.getString(_TL_('Audience ads')),
  description: i18n.getString(_TL_('Show highly relevant ads to your audience and reach them in the right place at the right time on any device. Microsoft Audience ads can appear on sites like MSN, Microsoft Start, Microsoft Edge, Outlook, and partners. ')),
  helpTopicId: 'app54714',
  img: AudienceAdsImg,
  'aria-label': showAsCampaignType ? i18n.getString(_TL_('Audience')) : i18n.getString(_TL_('Audience ads')),
}, /* {
  id: 'SmartAds',
  title: i18n.getString(_TL_('Smart ads')),
  description: i18n.getString(_TL_('Smart ads description Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo.')),
  img: ProductAdsImg,
} */];

export const shoppingCampaignTypes = {
  smart: 'SmartShoppingCampaign',
  standard: 'StandardShoppingCampaign',
};

export const campaignTypes = {
  standard: 'StandardCampaign',
  perfMax: 'PerfMaxCampaign',
};

export const xandrVideoCampaignTypes = {
  xandrVideoWeb: 'XandrVideoWebCampaign',
  xandrVideoCtv: 'XandrVideoCtvCampaign',
};

export const adImpressionsCampaignTypes = {
  nativeAds: 'NativeAdsCampaign',
  displayAds: 'DisplayAdsCampaign',
};

export const sponsoredProductCampaignTypes = {
  spa: 'MicrosoftRetailerNetwork',
  spb: 'SponsoredPromotionsByBrand',
};

export const perfMaxCampaignTypeConfig = i18n => ({
  id: campaignTypes.perfMax,
  title: i18n.getString(_TL_('Performance Max')),
  description: i18n.getString(_TL_('Easily create and manage your campaign, optimize ads to reach the right audience at the right time, and drive performance to meet your advertising goals using Microsoft AI. We\'ll determine which audiences and assets are best for your ads based on your settings. All ads will be eligible to surface on the entire Microsoft Advertising Network.')),
  img: PerformanceMaxImg,
  'aria-label': i18n.getString(_TL_('Performance Max')),
  helpTopicId: 'app54826',
});

export const smartShoppingCampaignTypeConfig = i18n => ({
  id: shoppingCampaignTypes.smart,
  title: i18n.getString(_TL_('Smart Shopping')),
  description: i18n.getString(_TL_('Maximize your return by using automated bidding and targeting on the Microsoft Advertising Network. Smart Shopping campaigns take priority over Standard Shopping campaigns which target the same set of products.')),
  img: SmartShoppingImg,
  'aria-label': i18n.getString(_TL_('SmartShopping')),
});

export const standardShoppingCampaignTypeConfig = i18n => ({
  id: shoppingCampaignTypes.standard,
  title: i18n.getString(_TL_('Standard Shopping')),
  description: i18n.getString(_TL_('Pick your products, bid strategy, budget, and targeting. Your ads can show on the Microsoft Advertising Network.')),
  img: StandardShoppingImg,
  'aria-label': i18n.getString(_TL_('Standard Shopping')),
});

export const shoppingCampaignTypeConfig = (i18n, permissions) => _.compact([!permissions.dynamic.SSCDeprecation && smartShoppingCampaignTypeConfig(i18n), standardShoppingCampaignTypeConfig(i18n)]);

export const xandrVideoCampaignTypeConfig = i18n => [
  {
    id: xandrVideoCampaignTypes.xandrVideoWeb,
    title: i18n.getString(_TL_('Online video ads')),
    description: i18n.getString(_TL_('Online video ads engage potential customers on websites across desktop, tablet, and mobile devices while they\'re streaming media and browsing the web.')),
    img: VideoCampaignWeb,
    'aria-label': i18n.getString(_TL_('Online video ads')),
  },
  {
    id: xandrVideoCampaignTypes.xandrVideoCtv,
    title: i18n.getString(_TL_('Connected TV (CTV) ads')),
    description: i18n.getString(_TL_('Reach your audience with video ads on CTV streaming services. These ads are designed to increase engagement and maximize completed views of your CTV ads.')),
    img: VideoCampaignCTV,
    'aria-label': i18n.getString(_TL_('Connected TV (CTV) ads')),
  },
];

export const sponsoredProductCampaignTypeConfig = (i18n, permissions) => [
  // If MranDeprecation is enabled, we want to hide the option instead of disabling the option
  ...(_.get(permissions, ['dynamic', 'MranDeprecation'], false) ? [] : [{
    id: sponsoredProductCampaignTypes.spa,
    title: i18n.getString(_TL_('Sponsored retail ads')),
    description: (
      <ReactTemplate
        model={{ bold: text => <b>{text}</b> }}
        template={i18n.getString(_TL_('Target in-market customers with {{bold}}product ads across Bing and the retailer\'s network.{{/bold}}'))}
      />
    ),
    img: MicrosoftRetailerNetworkImg,
    'aria-label': i18n.getString(_TL_('Sponsored retail ads')),
  }]),
  {
    id: sponsoredProductCampaignTypes.spb,
    title: i18n.getString(_TL_('Sponsored Promotions for brands')),
    description: (
      <ReactTemplate
        model={{ bold: text => <b>{text}</b> }}
        template={i18n.getString(_TL_('Target in-market customers with {{bold}}cashback promotions when they shop on Edge.{{/bold}}'))}
      />
    ),
    disabled: !permissions.dynamic.SponsoredPromotionsByBrands,
    img: SponsoredPromotionsByBrandImg,
    'aria-label': i18n.getString(_TL_('Sponsored Promotions for brands')),
  },
];

export const adImpressionsCampaignTypeConfig = i18n => [
  {
    id: adImpressionsCampaignTypes.nativeAds,
    title: i18n.getString(_TL_('Audience ads')),
    description: i18n.getString(_TL_('Show personalized, visually rich, responsive ads that integrate naturally into webpage content. ')),
    helpTopicId: 'app54714',
    img: NativeAdsImg,
    'aria-label': i18n.getString(_TL_('Native ads')),
  },
  {
    id: adImpressionsCampaignTypes.displayAds,
    title: i18n.getString(_TL_('Display ads')),
    description: i18n.getString(_TL_('Showcase your brand with eye-catching, customized image ads, including banner, billboard, and half-page display placements.')),
    img: DisplayAdsImg,
    'aria-label': i18n.getString(_TL_('Display ads')),
  },
];

export const search = (i18n, showAsCampaignType) => [{
  id: 'SearchAds',
  title: showAsCampaignType ? i18n.getString(_TL_('Search')) : i18n.getString(_TL_('Search ads')),
  description: i18n.getString(_TL_('Search ads appear as results to search queries on the Bing Network. They are text-based ads with formatting and image enhancements')),
  img: SearchAdsImg,
  'aria-label': showAsCampaignType ? i18n.getString(_TL_('Search')) : i18n.getString(_TL_('Search ads')),
}, {
  id: 'AudienceAds',
  title: showAsCampaignType ? i18n.getString(_TL_('Audience')) : i18n.getString(_TL_('Audience ads')),
  description: i18n.getString(_TL_('Audience ads appear to people on the Microsoft Advertising Network based on who they are interested in. They are responsive ads that fit with the subject matter and visual design of the surrounding experience. Audience ads must comply with Microsoft Advertising policies and are also subject to additional requirements listed in our ')),
  audienceAdsPolicy: i18n.getString(_TL_('Audience ads Policy')),
  period: i18n.getString(_TL_('.')),
  img: AudienceAdsImg,
  'aria-label': showAsCampaignType ? i18n.getString(_TL_('Audience')) : i18n.getString(_TL_('Audience ads')),
}, /* {
  id: 'SmartAds',
  title: i18n.getString(_TL_('Smart ads')),
  description: i18n.getString(_TL_('Smart ads description Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo.')),
  img: ProductAdsImg,
} */];
